import {
  MarketingCampaignType,
  Offer,
  ProductDiscountMarketingCampaignConfig,
  ThresholdMarketingCampaignConfig,
} from '../../../../../../1_types/genericTypes';

export const getTootltipTextFromOffer = (offer: Offer): string => {
  if (!offer) return null;
  switch (offer.type) {
    case MarketingCampaignType.BUY_ONE_GET_ONE_PRODUCT:
      return '1 acheté = 1 offert';
    case MarketingCampaignType.BUY_ONE_GET_ONE_DIFFERENT_PRODUCT:
      return '1 acheté = 1 autre offert';
    case MarketingCampaignType.PRODUCT_DISCOUNT:
      return `${(offer.config as ProductDiscountMarketingCampaignConfig).discount.value
        }% de réduction`;

    case MarketingCampaignType.PRODUCT_DISCOUNT_AFTER_THRESHOLD:
      const config = offer.config as ThresholdMarketingCampaignConfig;
      return window.innerWidth > 1024 ? `-${config.discount.value}% à partir de ${config.threshold}€ d'achat` : `-${config.discount.value}% à partir de ${config.threshold}€`;

    default:
      return null;
  }
};
